import api from './api';

export interface LoginResponse {
  success?: boolean;
  token?: string;
  user?: any;
  // El backend anida estos campos (ver LoginResult en apps/core/src/modules/auth/service.ts)
  // — nunca vienen planos en la respuesta.
  requiresMfaSetup?: {
    enrollId: string;
    qrDataUrl: string;
    manualKey: string;
  };
  requiresMfaVerify?: {
    challengeId: string;
  };
}

export interface MFAResponse {
  success: boolean;
  user: any;
  token: string;
}

export interface TenantMatch {
  tenantId: string;
  tenantName: string;
}

export interface IdentifyResponse {
  matches: TenantMatch[];
}

/** Paso 1 del login en el dominio compartido: resuelve tenant(s) por email. */
export async function identifyTenant(email: string): Promise<IdentifyResponse> {
  const { data } = await api.post('/auth/identify', { email });
  return data;
}

export async function login(email: string, password: string, tenantId?: string): Promise<LoginResponse> {
  const { data } = await api.post('/auth/login', { email, password, ...(tenantId ? { tenantId } : {}) });
  if (data.success && data.token) {
    localStorage.setItem('jwt', data.token);
  }
  return data;
}

export async function enrollMFA(enrollId: string, token: string): Promise<MFAResponse> {
  const { data } = await api.post('/auth/mfa/enroll-confirm', { enrollId, token });
  if (data.success && data.token) {
    localStorage.setItem('jwt', data.token);
  }
  return data;
}

export async function verifyMFA(challengeId: string, token: string): Promise<MFAResponse> {
  const { data } = await api.post('/auth/mfa/verify', { challengeId, token });
  if (data.success && data.token) {
    localStorage.setItem('jwt', data.token);
  }
  return data;
}

export async function logout(): Promise<void> {
  try {
    await api.post('/auth/logout');
  } finally {
    localStorage.removeItem('jwt');
  }
}

export interface UpdateProfileResponse {
  user: { id: string; email: string; name: string | null; role: string };
}

export async function updateProfile(name: string): Promise<UpdateProfileResponse> {
  const { data } = await api.put('/auth/me', { name });
  return data;
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await api.put('/auth/password', { currentPassword, newPassword });
}
